/* eslint max-len: 0 */
import React from 'react';

const AboutInfo = () => (
  <section id="services" className="g-theme-bg-blue-dark-v1 bg-sp-blue g-py-100">
    <div className="container text-center g-max-width-750 g-mb-30">
      <div className="text-uppercase u-heading-v2-4--bottom g-brd-primary g-mb-30">
        <h3 className="h3 g-letter-spacing-5 g-font-size-12 g-font-weight-400 g-color-primary g-mb-25">
          Te preguntarás
        </h3>
        <h2 className="u-heading-v2__title g-line-height-1 g-letter-spacing-2 g-font-size-30 g-font-size-40--md g-color-white mb-0">
          ¿Qué es el Consumo?
        </h2>
      </div>

      <p className="g-color-white-opacity-0_7 mb-0">
        Es la cantidad de energía que utilizamos en un determinado tiempo, la cual se mide en{' '}
        <i>
          watts-hora <strong>(Wh)</strong>
        </i>. Esta se puede calcular durante una hora, día, un mes, un año, etc. Generalmente, los
        recibos mensuales de electricidad calculan el consumo durante un mes.
        <br />
        En términos matemáticos, el consumo es la <strong>multiplicación</strong> de la{' '}
        <strong>potencia</strong> de un aparato por la cantidad de <strong>horas utilizadas</strong>.
        La potencia es la cantidad de trabajo, o fuerza, que necesita un aparato y esta se mide en{' '}
        <i>
          watts <strong>(W)</strong>
        </i>.
        <br />
        <br />
        Por ejemplo, si tenemos un TV de 32”, podemos buscar en sus especificaciones y encontraremos
        la potencia del televisor. Digamos que la potencia de esa TV es de <i>70W</i>. Entonces
        calculamos las horas que estará encendido en un día, las que pueden ser <i>4 horas</i> para
        este ejemplo.
        <br />
        <br />
        Calculamos: <br />
        <i>
          70W x 4h = <strong>280 Wh</strong>.
        </i>
        <br />
        <br />
        Con este ejemplo, obtenemos un consumo diario de 280Wh con el televisor.{' '}
      </p>
    </div>
  </section>
);

export default AboutInfo;



// WEBPACK FOOTER //
// ./src/components/Home/AboutInfo/index.js